import { styled, u } from '../../shared/theming-sc'

const StyledCheckboxWrapper = styled.div`
  top: 2px;
  position: relative;
  height: 14px;
  display: inline-block;
  margin-right: 5px;
  input[type="checkbox"] {
    display: none;
    position: absolute;
  }

  input[type="checkbox"] + span {
    display: block;
    width: 14px;
    height: 14px;
    border-radius: 3px;
    transition: all .2s ease;
  }

  input[type="checkbox"]:checked + span:after {
    display: block;
  }

`

const StyledTick = styled.span`
  background-color: white;
  border: 1px solid ${u.getColor('greyLight')};
`

const SelectedStyledTick = styled.span`
  background-color: ${u.getColor('primary')};
  border: 1px solid ${u.getColor('primary')};

  :after{
    content: "";
    display: none;
    position: absolute;
    left: 5px;
    top: 3px;
    width: 4px;
    height: 7px;
    border: 1.5px solid white;
    border-width: 0 1.5px 1.5px 0;
    transform: rotate(45deg);
  }
`

const PartiallySelectedStyledTick = styled.span`
  background-color: ${u.getColor('primary')};
  border: 1px solid ${u.getColor('primary')};

  :after{
    content: "";
    display: none;
    position: absolute;
    left: 4px;
    top: 6px;
    width: 6px;
    border: 1.5px solid white;
    border-width: 0 0 1.5px 0;
  }
`

const DisabledStyledTick = styled.span`
  border: 1px solid ${u.getColor('greyMuted')};
`

const DisabledSelectedStyledTick = styled.span`
  background-color: ${u.getColor('greyMuted')};
  border: 1px solid ${u.getColor('greyMuted')};

  :after{
    content: "";
    display: none;
    position: absolute;
    left: 5px;
    top: 3px;
    width: 4px;
    height: 7px;
    border: 1.5px solid white;
    border-width: 0 1.5px 1.5px 0;
    transform: rotate(45deg);
  }
`

const DisabledPartiallySelectedStyledTick = styled.span`
  background-color: ${u.getColor('greyMuted')};
  border: 1px solid ${u.getColor('greyMuted')};

  :after{
    content: "";
    display: none;
    position: absolute;
    left: 4px;
    top: 6px;
    width: 6px;
    border: 1.5px solid white;
    border-width: 0 0 1.5px 0;
  }
`
const StyledCheckbox = styled.input`


`

export {
  StyledCheckboxWrapper,
  StyledTick,
  StyledCheckbox,
  SelectedStyledTick,
  PartiallySelectedStyledTick,
  DisabledStyledTick,
  DisabledSelectedStyledTick,
  DisabledPartiallySelectedStyledTick
}
